import { Check, MapPin } from "lucide-react";
import BookButton from "@/components/np/BookButton";
import Reveal from "@/components/np/Reveal";
import { clinics } from "@/content";

const cityOf = (id) => clinics.find((c) => c.id === id)?.city;

export default function TreatmentBlock({ t, index }) {
  return (
    <Reveal as="article" id={t.id} aria-labelledby={`${t.id}-title`} className="scroll-mt-40 rounded-[32px] bg-white p-6 ring-1 ring-line sm:p-10" data-testid={`treatment-${t.id}`}>
      <div className="grid gap-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="font-serif text-lg text-pine">{String(index + 1).padStart(2, "0")}</span>
          <h2 id={`${t.id}-title`} className="mt-2 font-serif text-3xl text-ink sm:text-4xl">{t.name}</h2>
          {t.alt && <p className="mt-1 text-sm text-muted">{t.alt}</p>}
          <p className="mt-4 text-lg leading-relaxed text-ink/85">{t.short}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            {t.locations.map((l) => (
              <span key={l} className="inline-flex items-center gap-1.5 rounded-full bg-sage/45 px-3 py-1 text-xs font-semibold text-forest">
                <MapPin className="h-3.5 w-3.5" aria-hidden="true" /> {cityOf(l)}
              </span>
            ))}
          </div>
          <BookButton testId={`treatment-${t.id}-book-button`} className="mt-7" />
        </div>
        <div className="grid gap-8 lg:col-span-7">
          <section>
            <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-muted">Vad är det?</h3>
            <p className="mt-3 leading-relaxed text-ink/85">{t.what}</p>
          </section>
          <div className="grid gap-8 sm:grid-cols-2">
            <section>
              <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-muted">Kan vara aktuellt vid</h3>
              <ul className="mt-3 space-y-2">
                {t.usedFor.map((u) => (
                  <li key={u} className="flex gap-2.5 text-[15px] text-ink"><Check className="mt-1 h-4 w-4 shrink-0 text-pine" aria-hidden="true" />{u}</li>
                ))}
              </ul>
            </section>
            <section>
              <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-muted">Så går det till</h3>
              <ol className="mt-3 space-y-2">
                {t.visit.map((v, i) => (
                  <li key={v} className="flex gap-3 text-[15px] text-ink"><span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-cream text-[11px] font-bold text-pine ring-1 ring-line">{i + 1}</span>{v}</li>
                ))}
              </ol>
            </section>
          </div>
          <p className="rounded-2xl bg-cream p-4 text-sm leading-relaxed text-muted">{t.aftercare}</p>
        </div>
      </div>
    </Reveal>
  );
}
